
/**
 * @fileOverview Search Controller Module
 * @Author: Pat
 * @modified 10/24/2016
 *
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/SearchController',['require','jquery','lib/Util','controllers/SearchTypeAheadController','GlobalEventDispatcher','GlobalResizeListener'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');
        var SearchTypeAheadController = require('controllers/SearchTypeAheadController');
	    var GlobalEventDispatcher = require('GlobalEventDispatcher');
	    var GlobalResizeListener = require('GlobalResizeListener');

        var SearchController = function (trigger) { 
			this.searchBar = $('#js-searchBar');
			this.searchFooterBar = $('#js-searchBarFooter');
			this.searchWidth = this.searchBar.width();
			this.searchInput = this.searchBar.find('.js-searchInput');
			this.searchInputFooter = this.searchFooterBar.find('.js-searchInput');
			this.searchSubmit = this.searchBar.find('button[type=submit]');
			this.inputWidth = this.searchInput.width();
			this.searchMarkets = this.searchBar.find('.js-searchMarkets');
			this.ftrSearchMarkets = $('.MMM--ftSection .js-searchMarkets');
			this.styledDDContainer = '';
			this.styledDD = '';
			this.styledDDHd = '';
			this.ftStyledDD = '';
			this.mobileSearchBtn = $('#js-mobileSearchBtn');
			this.mobileSearchBar ='';
			this.siteHd = $('#js-siteHd');
			this.gsn = $('#js-gsnList');
			this.searchOpen = false;
			this.searchDDOpen = false;
			this.searchExpanded = false;
			this.searchPadding = 5;
			this.typeAheadEnabled = true;
			this.persistantSearchTerm = true;
			this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();
			this.globalResizeListener = GlobalResizeListener.getResizeListener();
			this.replaceChars = [
				{
					name: 'Ideographic Space',
					toBeReplaced: '\u3000',
					replaceWith: '\u0020'
				}
			]

			this.init();
        };

		SearchController.prototype.init = function(){
			this.createDropdown();
			this.setupHandlers();

			if(window.SETTINGS.typeAhead !== undefined && window.SETTINGS.typeAhead === false){
				this.typeAheadEnabled = false;
			}

			if(this.typeAheadEnabled !== false){
				if($('#js-bodyWrapper').attr('data-mobileGSNLoaded') === 'true'){
					this.typeAheadInit();
				} else{
					this.eventDispatcher.subscribe('mobileGSNBuilt', this.typeAheadInit.bind(this));
				}
			}
			//To disable persistant search term use the settings in siteconfig to set it false
			if(window.SETTINGS.persistantSearchTerm !== undefined && window.SETTINGS.persistantSearchTerm === false){
				this.persistantSearchTerm = false;
			}
			//Enabling persistant search term
			if(this.persistantSearchTerm !== false){
				$debug('Initializing persistantSearch...', 'searchController');
				this.persistantSearch();
			}

			$debug('Initializing Search Controller Module...', 'searchController');

			return this;
		};

		SearchController.prototype.setupHandlers = function(){
			var self = this,
				screenSize = $getLayout();

			// Event Handlers for closing the navigation
			$('body').on('click', function(event){
				if(self.searchDDOpen && !self.searchDDClick(event)){
					event.preventDefault();
					
					$('.MMM--styledMarkets').each(function(){
						self.styledDDClose(event, $(this));
					});
				} else if(self.searchOpen && !self.searchClick(event)){
					event.preventDefault();
					self.mobileSearchDisable(event, $(event.target));
				} else if(self.searchDDClick(event)){
					var $target = $(event.target).hasClass('MMM--styledMarkets') ? $(event.target) : $(event.target).parents('.MMM--styledMarkets');

					if($target.hasClass('MMM--styledMarkets')){
						event.preventDefault();

						if($target.hasClass('MMM--isActive')){
							self.styledDDClose(event, $target);
						} else{
							self.styledDDOpen(event, $target);
						}
					}
				} else if($(event.target).hasClass('js-searchInput') && $(event.target).parents('#js-siteHd').length > 0){
					self.searchInput.addClass('MMM--isActive');
					self.searchBar.addClass('MMM--isActive');
					self.searchExpanded = true;
					screenSize = $getLayout();

					if(screenSize === 'Desktop' || screenSize === 'Luxury'){
						self.siteHd.outerHeight(self.siteHd.outerHeight());
						self.gsn.hide();
						self.calculateSearch('expand');
					}
				} else if(self.searchExpanded && !self.searchDDClick(event) && !self.searchTAClick(event)){
					self.searchInput.removeClass('MMM--isActive');
					self.searchBar.removeClass('MMM--isActive');
					self.searchExpanded = false;

					if(screenSize === 'Desktop' || screenSize === 'Luxury'){
						self.gsn.show();
						self.calculateSearch('collapse');
					}	
				} else{
					var $target = $(event.target).is(self.mobileSearchBtn) ? $(event.target) : $(event.target).parents('#js-mobileSearchBtn');

					if($target.is(self.mobileSearchBtn)){
						event.preventDefault();
						self.searchBtnClick(event, $target);
					}
				}
			});
            
            // Need to validate input before submission occurs
			this.searchBar.on('submit', function(e){
				if(self.searchInput.val().trim() === ''){
					e.preventDefault();
				} else {
					self.sanitizeSearch($(this), self.searchInput, e);
				}
			});

			$(this.searchFooterBar.selector + ' > form').on('submit', function(e){
				if(self.searchInputFooter.val().trim() === ""){
					e.preventDefault();
				}
			});

			this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE, this.calculateSearch.bind(this));

			return this;
		};

		SearchController.prototype.createDropdown = function(){
			var self = this,
				$ddContainer = $('<div class="MMM--styledMarkets"></div>'),
				$ddHeader = $('<div class="MMM--styledMarketsHd js-styledMarketsHd"><i class="MMM--icn MMM--icn_arrowDown"></i></div>'),
				$ddOptions = $('<ul class="MMM--styledMarketsOpts"></ul>'),
				$ddSelected = $('<span class="MMM--styledMarketsSelected js-styledMarketsSelected"></span>');

			self.styledDDContainer = $ddContainer;
			self.styledDD = $ddOptions;
			self.styledDDHd = $ddHeader;
			$ddContainer.append($ddHeader.prepend($ddSelected)).append($ddOptions);

			this.searchMarkets.find('option').each(function(i){
				var $ddOpt = $('<li><a href="#" class="js-styledMarketOpt" data-value="' + $(this).val() + '">' + $(this).text() + '</a></li>');

				// If this is the first option OR if it is selected than this should be the text at the top of the styled dropdown
				if(i === 0 || $(this).attr('selected') === 'selected' || $(this).attr('selected') === 'true'){
					$ddSelected.text($ddOpt.text());
				}

				$ddOptions.append($ddOpt);
			});

			this.searchMarkets.addClass('MMM--isStyled').after($ddContainer);

			if(this.ftrSearchMarkets.length > 0){
				this.ftStyledDD = $ddContainer.clone();
				this.ftrSearchMarkets.addClass('MMM--isStyled').after(this.ftStyledDD);
			}

			$('.js-styledMarketOpt').on('click', function(event){
				self.styledDDChange(event, $(this));
			});

			// Update widths just in case
			this.searchWidth = this.searchBar.width();
			this.inputWidth = this.searchInput.width();

			// Calculate the initial size of the search input
			this.calculateSearch('resize');

			return this;
		};

		SearchController.prototype.styledDDOpen = function(event, $element){
			var $target = $element.find('.MMM--styledMarketsOpts').addClass('MMM--isActive');
			
			$element.addClass('MMM--isActive');
			$target;
			this.searchDDOpen = true;

			// Check to see if the dropdown height exceeds the length of the page
			this.extendBody($target);

			return this;
		};

		SearchController.prototype.styledDDClose = function(event, $element){
			$element.removeClass('MMM--isActive');
			$element.find('.MMM--styledMarketsOpts').removeClass('MMM--isActive');
			this.searchDDOpen = false;

			return this;
		};

		SearchController.prototype.styledDDChange = function(event, $element){
			var $container = $element.parents('.MMM--styledMarkets');

			$container.find('.js-styledMarketsSelected').text($element.text());
			$container.siblings('.js-searchMarkets').val($element.data('value')).change();
			this.styledDDClose(event, $container.find('.js-styledMarketsHd'));

			// Update widths just in case
			this.searchWidth = this.searchBar.width();
			this.inputWidth = this.searchInput.width();
			this.calculateSearch('ddChange');

			return this;
		};

		SearchController.prototype.extendBody = function($element){
			// If the dropdown extends off the page, we need to resize some elements
			var bdyHeight = $('body').height(),
				ddHeight = $element.outerHeight(),
				ddOffset = $element.offset().top,
				heightDif = ddHeight+ddOffset-bdyHeight;
				
			$debug('dd Height:' + ddHeight, 'searchController');
			$debug('dd Offset:' + ddOffset, 'searchController');
			$debug('Height difference:' + heightDif, 'searchController');
			if(heightDif > 0){
				$debug('Dropdown is too long for page, adding pixels to the footer height:' + heightDif, 'searchController');

				// Add the height difference to the footer container
				$('.MMM--theme-ft').height($('.MMM--theme-ft').height() + heightDif);
			}

			return this;
		};

		SearchController.prototype.searchBtnClick = function(event, $element){
			var self = this;
			if(!self.searchOpen){
				self.mobileSearchEnable($element);
			} else{
				self.mobileSearchDisable(event, $element);
			}

			return this;
		};

		SearchController.prototype.mobileSearchEnable = function($element){
			var self = this;
			$element.parent('li').addClass('MMM--isActive');

			if(self.mobileSearchBar.length > 0){
				self.mobileSearchBar.show();
			} else{
				self.createMobileSearch();
			}
			self.searchOpen = true;

			return this;
		};

		SearchController.prototype.mobileSearchDisable = function(event, $element){
			this.mobileSearchBtn.parent('li').removeClass('MMM--isActive');
			this.mobileSearchBar.hide();
			this.searchOpen = false;

			return this;
		};

		SearchController.prototype.createMobileSearch = function(){
			var self = this;
			var mobileSearch = self.searchBar.clone();

			self.siteHd.append('<div class="MMM--mobileSearchBar js-mobileSearchBar"></div>');
			self.mobileSearchBar = self.siteHd.find('.js-mobileSearchBar');
			self.mobileSearchBar.append(mobileSearch);

			return this;
		};

		SearchController.prototype.calculateSearch = function(behavior){
			var searchWidth = this.searchWidth,
				inputWidth = this.searchInput.width(),
				ddWidth = Math.ceil(this.styledDDContainer[0].getBoundingClientRect().width),
				iconWidth = this.searchBar.find('button').outerWidth(),
				screenSize = $getLayout();

			behavior = !behavior ? 'resize' : behavior;

			if(behavior === 'expand'){
				this.searchBar.css({width: ''});
				this.searchInput.outerWidth(this.searchBar.width()-ddWidth-this.searchPadding);
			} else if(behavior === 'collapse'){
				this.searchBar.css({width: ''});

				// Recalculate width as if the dropdown had changed
				this.calculateSearch('ddChange');
			} else if(behavior === 'ddChange'){
				this.searchInput.outerWidth(this.searchBar.width()-ddWidth-this.searchPadding);

				// Update the footer search bar as well
				if(!!this.ftStyledDD.siblings){
					this.ftStyledDD.siblings('.js-searchInput').outerWidth(this.ftStyledDD.parents('.MMM--searchBar').width()-Math.ceil(this.ftStyledDD[0].getBoundingClientRect().width));
				}
			} else if(behavior === 'resize'){
				if(screenSize === 'Desktop' || screenSize === 'Luxury'){
					// Reset width overrides for the search container and input
					this.searchBar.css({width: ''});
					this.searchInput.css({width: ''});

					// Recalculate width as if the dropdown had changed
					this.calculateSearch('ddChange');
				} else if(screenSize === 'Tablet'){
					this.searchInput.outerWidth(this.searchBar.width()-ddWidth-this.searchPadding);

					// Update the footer search bar as well
					if(!!this.ftStyledDD.siblings){
						this.ftStyledDD.siblings('.js-searchInput').outerWidth(this.ftStyledDD.parents('.MMM--searchBar').width()-Math.ceil(this.ftStyledDD[0].getBoundingClientRect().width));
					}
				} else if(screenSize === 'Mobile'){
					// Mobile search is not dynamic so let it default to CSS
					this.searchInput.css({width: ''});

					if(!!this.ftStyledDD.siblings){
						this.ftStyledDD.siblings('.js-searchInput').css({width: ''});
					}
				}
			}

			return this;
		};

		SearchController.prototype.searchClick = function(event){
			return ($(event.target).is(this.mobileSearchBar) || $(event.target).parents('.js-mobileSearchBar').length > 0 || $(event.target).is(this.mobileSearchBtn) || $(event.target).parents('#js-mobileSearchBtn').length > 0);
		};

		SearchController.prototype.searchDDClick = function(event){
			return ($(event.target).hasClass('MMM--styledMarkets') || $(event.target).parents('.MMM--styledMarkets').length > 0);
		};

		SearchController.prototype.searchTAClick = function(event){
			return ($(event.target).hasClass('js-typeAhead') || $(event.target).parents('.js-typeAhead').length > 0);
		};

		SearchController.prototype.typeAheadInit = function(event){
			$('.js-searchInput').each(function(){
				// Re-added on 9/29, SearchTypeAheadController has been modified to filter queries for three characters per term
				new SearchTypeAheadController($(this));
			});

			return this;
		};

		SearchController.prototype.persistantSearch = function(){
			var self = this,
				urlParamNtt = urlHash['Ntt'], //grab the search param from url Ntt
				urlParamq = urlHash['q']; //grab for the search param from url q
				$debug('in persistantSearchTerm method', 'searchController');
			if (urlParamNtt !== undefined && urlParamNtt !== ''){
				$debug('search term Ntt found! = ' + urlParamNtt, 'searchController');
				$('.js-searchInput').val(decodeURIComponent((urlParamNtt).replace(/\+/g, '%20'))); // set the searchinput value, decode and replace+ from the urlparam Ntt. It appears url replaces the spaces with +
			} else if (urlParamq !== undefined && urlParamq !== ''){
				$debug('search term q found! = ' + urlParamq, 'searchController');
				$('.js-searchInput').val(decodeURIComponent((urlParamq).replace(/\+/g, '%20'))); // set the searchinput value, decode and replace+ from the urlparam q. It appears url replaces the spaces with +
			} else {
				$debug('no search term found!', 'searchController');
			}

			return this;
		};

		SearchController.prototype.sanitizeSearch = function($searchForm, $searchInput, e){
			$debug('Checking search input for characters that need to be replaced before submission occurs...', 'searchController')

			var replaceArr = this.replaceChars,
				isClean = true;

			for (var i=0,l=replaceArr.length; i<l; i++) {
				var thisStr = replaceArr[i],
				    replaceStr = thisStr.toBeReplaced;
				
				if ($searchInput.val().indexOf(replaceStr) > -1) {
					$debug('  Found a character the must be replaced: ' + thisStr.name || replaceStr, 'searchController');

					e.preventDefault();
					isClean = false;

					$searchInput.val($searchInput.val().replace(replaceStr, thisStr.replaceWith));
				}
			}

			if (!isClean) { // If the function had to replace any characters, re-submit the form and it should come back clean the next time
				$searchForm.submit();
			}

			return;
		};

        return SearchController;
    });

}(MMMRequire));